export class DateModel
{
  Date: Date;
  Topic: string;
  Content: string;
}



// WEBPACK FOOTER //
// ./src/app/main/services/date.model.ts